export default __webpack_public_path__ + "f5b95a3f05e1447d74ef406f882e43a8.svg";